import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { useChartDimensions } from '../../hooks/dimensions'
import { csv } from 'd3-fetch'
import { Flex } from '../atoms/Basics'
import Card from '../molecules/Card'
import Note from '../atoms/Note'
import expand from '../../assets/svgs/expand.svg'

const CardContainer = styled.div`
  max-width: ${(props) => props.theme.widths[2]};
  margin: 0 auto;
  //padding: 4rem 0 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 1rem;
  row-gap: 1rem;
  ${Mq.lg} {
    grid-template-columns: 1fr 1fr;
  }
  ${Mq.sm} {
    grid-template-columns: 1fr;
  }
`

const StyledDiv = styled.div`
  max-width: ${(props) => props.theme.widths[1]};
  margin: 0 auto;
  padding: 0 0 2rem;
`
const Expand = styled(Flex)`
  max-width: ${(props) => props.theme.widths[1]};
  margin: 0 auto;
  padding: 4rem 0 1rem;
  p {
    color: ${(props) => props.theme.colors.orange};
    //font-size: ${(props) => props.theme.fontSizes[0]};
    font-weight: 700;
    margin-right: 0.5rem;
  }
`
const Cards = ({ note }) => {
  const [strengthData, setStrengthData] = useState(null)
  const [weaknessData, setWeaknessData] = useState(null)
  const [techUseData, setTechUseData] = useState(null)
  const [selectedRow, setSelectedRow] = useState(1)
  const [maxVal, setMaxVal] = useState()
  const [ref, dimensions] = useChartDimensions()

  useEffect(() => {
    Promise.all([
      csv('./data/strengths.csv'),
      csv('./data/weaknesses.csv'),
      csv('./data/techUse.csv')
    ]).then((data) => {
      setStrengthData(data[0])
      setWeaknessData(data[1])
      setTechUseData(data[2])
      setMaxVal(Math.max(findHighestVal(data[0]), findHighestVal(data[1])))
    })
  }, [])

  const findHighestVal = (data) => {
    const cols = data.columns
    const highVals = cols
      .map((col) => {
        return Math.max.apply(
          Math,
          data.map((d) => d[col])
        )
      })
      .slice(1)
    return Math.max(...highVals)
  }

  const handleSelectedRow = (i) => {
    const row = getRow(i)
    if (row === selectedRow) setSelectedRow(null)
    else setSelectedRow(row)
  }

  //get column names - same for each data set
  const cardTitles = strengthData ? strengthData.columns.slice(1) : null

  //divides data by card topic --> obj with strength/weakness name and value
  const groupData = (type, title) => {
    let obj = {}
    const data = type === 'Strengths' ? strengthData : weaknessData
    data?.map((d) => (obj[d[type]] = d[title]))
    return obj
  }

  const getRow = (i) => {
    //i.e. mq dimension (width at which grid changes) - 2rem --> 740 - 32 = 708
    if (dimensions.width < 708) {
      return i + 1
    }
    //1080 - 32 = 1048
    if (dimensions.width < 1048) {
      return i < 2
        ? 1
        : i < 4
        ? 2
        : i < 6
        ? 3
        : i < 8
        ? 4
        : i < 10
        ? 5
        : i < 12
        ? 6
        : i < 14
        ? 7
        : i < 16
        ? 8
        : i < 18
        ? 9
        : i < 20
        ? 10
        : 11
    }
    return i < 3
      ? 1
      : i < 6
      ? 2
      : i < 9
      ? 3
      : i < 12
      ? 4
      : i < 15
      ? 5
      : i < 18
      ? 6
      : i < 21
      ? 7
      : 8
  }
  return (
    <>
      <Expand justifyContent="center" alignItems="center">
        <p>click on a technology to expand and learn more</p>
        <img alt="expand" src={expand} />
      </Expand>
      <CardContainer ref={ref}>
        {cardTitles?.map((title, i) => (
          <Card
            key={i}
            title={title}
            sData={groupData('Strengths', title)}
            wData={groupData('Weaknesses', title)}
            pieData={techUseData?.find((d) => d.group === title)}
            i={i}
            handleSelectedRow={handleSelectedRow}
            selectedRow={selectedRow}
            row={getRow(i)}
            scaleTo={maxVal}
          />
        ))}
      </CardContainer>
      <StyledDiv>
        <Note note={note} />
      </StyledDiv>
    </>
  )
}

export default Cards
